import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura-compat';
import { AppComponent } from './app.component';
import { routes } from './app.routes';
import { LayoutModule } from './layout/layout.module';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { userReducer } from './store/user/user.reducer';
import { IAppState } from './store/interface/app.state.interface';
import { providePersistStore, localStorageStrategy } from '@ngrx-addons/persist-state';
import { includeKeys } from '@ngrx-addons/common';
import { dashboardReducer } from './store/tenant/dashboard.reducer';
import { settingsReducer } from './store/settings/settings.reducer';
import { environment } from '../environments/environment';

@NgModule({
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(routes),
        LayoutModule,
        CoreModule,
        SharedModule,
        // ========================================================================================
        // ------TODO: Firebase startup has been temporarily disabled under ticket #511.--------
        // ========================================================================================
        // AngularFireModule.initializeApp(environment.firebaseConfig),
        // AngularFireMessagingModule,
        StoreModule.forRoot<IAppState>({
            user: userReducer,
            dashboard: dashboardReducer,
            settings: settingsReducer,
        }),
        StoreDevtoolsModule.instrument({ maxAge: 25 }),
    ],
    declarations: [AppComponent],
    providers: [
        providePrimeNG({
            theme: { preset: Aura, options: { darkModeSelector: '.app-dark' } },
            license: environment.primeuiLicenseKey,
        }),
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
        providePersistStore({
            states: [
                {
                    key: 'user',
                    storage: localStorageStrategy,
                    source: (state) => state.pipe(includeKeys(['publishingTenantId'])),
                    storageKey: 'publishingTenantId',
                },
            ],
        }),
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
